import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import styles from "@/styles/OrderDetail/ChargingCountdown.module.less";
const { Text } = Typography;
const ChargingCountdown = observer(({ chargingSeconds }) => {
    const [remaining, setRemaining] = useState(chargingSeconds ?? 0);
    const intervalRef = useRef(null);
    // Re-anchor the countdown whenever realtime delivers a fresh server value.
    // This effect intentionally re-syncs `remaining` with the authoritative source.
    useEffect(() => {
        setRemaining(chargingSeconds ?? 0);
    }, [chargingSeconds]);
    // A single interval that ticks every second and clears itself when done.
    // It is (re-)started whenever `remaining` is seeded by the effect above — because
    // setting state triggers a re-render; the cleanup tears down the old interval
    // before the new one starts.
    useEffect(() => {
        if (remaining <= 0)
            return;
        intervalRef.current = setInterval(() => {
            setRemaining((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => {
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // Intentionally only run when `chargingSeconds` changes (re-anchored by Effect 1 above).
        // We do NOT list `remaining` here — that would restart the interval on every tick.
    }, [chargingSeconds]);
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    if (remaining <= 0) {
        return (_jsxs("div", { className: styles.countdown, children: [_jsx(ClockCircleOutlined, { className: styles.icon }), _jsx(Text, { className: styles.text, children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0441\u043A\u043E\u0440\u043E..." })] }));
    }
    return (_jsxs("div", { className: styles.countdown, children: [_jsx(ClockCircleOutlined, { className: styles.icon }), _jsxs(Text, { className: styles.text, children: ["\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0447\u0435\u0440\u0435\u0437", " ", _jsxs(Text, { strong: true, className: styles.value, children: [minutes > 0 ? `${minutes} мин ` : "", seconds, " \u0441\u0435\u043A"] })] })] }));
});
ChargingCountdown.displayName = "ChargingCountdown";
export default ChargingCountdown;
